import React from "react";
import { TextField, InputAdornment, Box } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { icons } from "../assets/icons/icons";

const SearchInput = ({
  placeholder = "Search...",
  value,
  onChange,
  width = "98%",
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        border: "2px solid #E8ECF4",
        borderRadius: "6px",
        overflow: "hidden",
        bgcolor: "#f9fafb",
      }}
    >
      <TextField
        fullWidth
        variant="standard"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        InputProps={{
          disableUnderline: true,
          endAdornment: (
            <InputAdornment position="end">
              {/* <SearchIcon sx={{ color: "#1e1e1e" }} /> */}
              <img src={icons.search} alt="search" />
            </InputAdornment>
          ),
        }}
        sx={{
          "& .MuiInputBase-input": {
            padding: "8px 12px",
            fontSize: "0.95rem",
          },
          width,
        }}
      />
    </Box>
  );
};

export default SearchInput;
